/**
 * Web component for sharing content using the Web Share API.
 */
class Share extends HTMLElement {
    constructor() {
        super();

        const link = this.querySelector('a');
        if (link) {
            link.addEventListener('click', this);
        }
    }

    /**
     * Share the content when the link is clicked.
     * @param {MouseEvent} event Click event from the link.
     */
    async handleEvent(event) {
        event.preventDefault();

        const link = this.querySelector('a');
        if (link && navigator.share) {
            const url = link.href || '';
            const text = link.title || link.getAttribute('alt') || link.textContent?.trim() || '';

            try {
                await navigator.share({ text, url, title: text });
            } catch {
                // do nothing if share fails (e.g., user cancelled)
            }
        }
    }
}

// Define the new web component
customElements.define('nilla-share', Share);

export default Share;
